import { render, staticRenderFns } from "./Bahn1Agenda.vue?vue&type=template&id=78461a20&scoped=true&"
import script from "./Bahn1Agenda.vue?vue&type=script&lang=js&"
export * from "./Bahn1Agenda.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1Agenda.vue?vue&type=style&index=0&id=78461a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78461a20",
  null
  
)

export default component.exports